import React, { useEffect, useState } from "react";
import { emiOverdueListApi, getUserDetailByLoanIdOptimisedApi,updateOverdueExpectedDetails } from "../AdminActionCreator.component";
import Popup from '../../../presentationals/Popup/Popup.component';
import Pagination from '@mui/material/Pagination';
import Loader from '../../../presentationals/Loader/Loader.component';
import NodataImage from '../../../../images/nodata.png';
import moment from "moment";
import { APIS } from "../../../../utils/api-factory";
import { monthStartDate, todayDate } from "../../Marketing/maketingComponents/utils/utils";
import { lastDayOfISOWeek } from "date-fns";

const OverDueEmi = ({ userDetailHandler }) => {
    const [processType, setProcessType] = useState('');
    const [objectData, setObjectData] = useState([]);
    const [loaderState, setLoader] = useState(false);
    const [popupStatus, setpopupStatus] = useState('No Data Found!');
    const [popupState, setpopupState] = useState(false);
    const [countData, setCounts] = useState('');
    const [startDate, setStartDate] = useState(moment().subtract(7, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [startDateToShow, setStartDateToShow] = useState(moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD'));
    const [endDateToShow, setendDateToShow] = useState(moment(new Date()).format('YYYY-MM-DD'));

    const [currentPage, setCurrentPage] = useState(1);
    const [viewPage, setViewPage] = useState(false)
    const itemsPerPage = 15;
    const [popupdata, setPopupdata] = useState({ show: false, data: '' })
    const [editableFields, setEditableFields] = useState({
        status: '',
        expectedDate: '',
        paymentExpectancy: ""
    })

    useEffect(() => {
        setLoader(true);
        emiOverdueListApi(
            moment(startDate).format('DD-MM-YYYY'),
            moment(endDate).format('DD-MM-YYYY'),
            callback => {
                setObjectData(callback.data);
                setCounts(callback);
                setLoader(false);
            }
        );
    }, []);

    const filterData = () => {
        setLoader(true);
        emiOverdueListApi(
            moment(startDate).format('DD-MM-YYYY'),
            moment(endDate).format('DD-MM-YYYY'),
            callback => {
                setObjectData(callback.data);
                setCounts(callback);
                setLoader(false);
                setCurrentPage(1);
            }
        );
    };
    const handleDate = (value, type) => {
        console.log(value)
        if (type === 'start') {
            setStartDate(value)
            setStartDateToShow(value)
        }
        if (type === 'end') {
            setEndDate(value)
            setendDateToShow(value)



        }
    }
    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };
    // const userDetailHandler = (data) => {
    //     // this.setState({ mainLoaderState: true })
    //     if (data.loanId != '' && data.loanId != null) {
    //         getUserDetailByLoanIdOptimisedApi(data.loanId, data.userId,
    //             (callBack) => {
    //                 // this.setState({
    //                 //     userState: false,
    //                 //     viewState: true,
    //                 //     allDetail: callBack,
    //                 //     userDetail: data,
    //                 //     mainLoaderState: false
    //                 // })
    //             })
    //     }


    // }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = objectData.slice(indexOfFirstItem, indexOfLastItem);


    const EditData = (e, data) => {
        setPopupdata({ show: true, data: data })
        setEditableFields({
            status: data.status,
            expectedDate:   moment(data?.expectedDate).format('YYYY-MM-DD') ,
            paymentExpectancy: data.paymentExpectancy
        })
    }

    const closePopup = () => {
        setPopupdata({ show: false, data: "" })
        setEditableFields({
            status: "",
            expectedDate: "",
            paymentExpectancy: ""
        })
    }

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditableFields((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const updateDetails =()=>{
        setLoader(true)
        const date = moment(editableFields?.expectedDate).format("DD-MM-YYYY")
        updateOverdueExpectedDetails(popupdata?.data?.emiId,editableFields?.status,date,editableFields?.paymentExpectancy,(callback)=>{
            console.log(callback)
            setLoader(false)
if(callback && callback?.message == "success" && callback?.status == 200){
    setpopupState(true)
    setpopupStatus("Entry Updated")
    closePopup()
}else{
    setpopupState(true)
    setpopupStatus("Error: Please Try again later!")
}
        })
    }

    const removePopup =()=>{
        setTimeout(()=>{
            setpopupState(false)
            setpopupStatus("")
        },3000)
    }

    return (
        <>
        {
            popupState ?
            <Popup popupStatus={popupStatus} closePopup={removePopup}/>
        :''}
            {viewPage === false ?
                <div className="container-fluid">
                    {console.log(startDateToShow, endDateToShow)}
                    {loaderState ? <Loader /> : ""}
                    <h3><b>Overdue EMI's</b></h3>
                    <div className="row">
                        <div className="col-sm-2 col-xs-12">
                            <label>Start Date </label>
                            <input
                                type="date"
                                className="form-control"
                                value={startDateToShow}
                                onChange={(e) => handleDate(e.target.value, 'start')}
                            />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label>End Date: </label>
                            <input
                                type="date"
                                className="form-control"
                                value={endDateToShow}
                                onChange={(e) => handleDate(e.target.value, 'end')}
                            />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <button className="btn btn-primary" style={{ marginTop: '22px', padding: '10px' }} onClick={filterData}>
                                Filter
                            </button>
                        </div>
                    </div>

                    {countData !== '' ?
                        <>
                            {/* <div className='row'>
                            <div className='col-sm-3 col-xs-12'>
                                <div className='shadow-card' style={{ marginTop: '30px', fontWeight: '700', minHeight: '133px' }}>
                                    Total Amount <br />
                                    <h3 style={{ color: 'grey', fontWeight: '700' }}>
                                        <i className='fa fa-rupee'></i>&nbsp;{Number(parseFloat(countData.total_amount).toFixed(2)).toLocaleString('en-IN')}
                                    </h3>
                                </div>
                            </div>
                            <div className='col-sm-3 col-xs-12'>
                                <div className='shadow-card' style={{ marginTop: '30px', fontWeight: '700', minHeight: '133px' }}>
                                    Principal Amount <br />
                                    <h3 style={{ color: 'grey', fontWeight: '700' }}>
                                        <i className='fa fa-rupee'></i>&nbsp;{Number(parseFloat(countData.total_principal_amount).toFixed(2)).toLocaleString('en-IN')}
                                    </h3>
                                </div>
                            </div>
                            <div className='col-sm-3 col-xs-12'>
                                <div className='shadow-card' style={{ marginTop: '30px', fontWeight: '700', minHeight: '133px' }}>
                                    Interest Amount <br />
                                    <h3 style={{ color: 'grey', fontWeight: '700' }}>
                                        <i className='fa fa-rupee'></i>&nbsp;{Number(parseFloat(countData.total_interest_amount).toFixed(2)).toLocaleString('en-IN')}
                                    </h3>
                                </div>
                            </div>
                            <div className='col-sm-3 col-xs-12'>
                                <div className='shadow-card' style={{ marginTop: '30px', fontWeight: '700', minHeight: '133px' }}>
                                    Penalty Amount <br />
                                    <h3 style={{ color: 'grey', fontWeight: '700' }}>
                                        <i className='fa fa-rupee'></i>&nbsp;{Number(parseFloat(countData.total_penalty_amount).toFixed(2)).toLocaleString('en-IN')}
                                    </h3>
                                </div>
                            </div>
                        </div> */}
                            <div className="paymentInsightsMain" style={{ margin: '20px 0px 40px 0px' }}>
                                <div className="paymentOverviewSection outerBoxWithPadding">
                                    <div className="heading" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <h4>Overview</h4>

                                    </div>
                                    <div className="PaymentBoxes">
                                        <div className="tabs" style={{ width: "25%" }}>
                                            <div className="subtabs" style={{ backgroundColor: '#ffe2e6', height: window.innerWidth < 1200 ? '170px' : '156px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'basline' }}>
                                                    <div className="circlesIcon" style={{ backgroundColor: '#fa5a7d' }}><i class="fa fa-cart-arrow-down" aria-hidden="true"></i></div>
                                                    <h5 className="bolder-font">{(0)?.toLocaleString("en-US")}</h5>

                                                </div>
                                                <h4>{'₹ ' + (Number(countData.total_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</h4>

                                                <h5>Total Amount</h5>
                                            </div>
                                        </div>
                                        <div className="tabs" style={{ width: "25%" }}>
                                            <div className="subtabs" style={{ backgroundColor: '#fff4de', height: window.innerWidth < 1200 ? '170px' : '156px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'basline' }}>
                                                    <div className="circlesIcon" style={{ backgroundColor: '#ff947a' }}><i class="fa fa-money" aria-hidden="true"></i></div>
                                                    <h5 className="bolder-font">{(0)?.toLocaleString("en-US")}</h5>

                                                </div>
                                                <h4>{'₹ ' + (Number(countData.total_principal_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</h4>

                                                <h5>Principal Amount</h5>
                                            </div>
                                        </div>
                                        <div className="tabs" style={{ width: "25%" }}>
                                            <div className="subtabs" style={{ backgroundColor: '#fff1c1', height: window.innerWidth < 1200 ? '170px' : '156px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'basline' }}>
                                                    <div className="circlesIcon" style={{ backgroundColor: '#dbb328' }}><i class="fa fa-money" aria-hidden="true"></i></div>
                                                    <h5 className="bolder-font">{(0)?.toLocaleString("en-US")}</h5>

                                                </div>
                                                <h4>{'₹ ' + (Number(countData.total_interest_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</h4>

                                                <h5>Interest Amount</h5>
                                            </div>
                                        </div>
                                        <div className="tabs" style={{ width: "25%" }}>
                                            <div className="subtabs" style={{ backgroundColor: '#dcfce7', height: window.innerWidth < 1200 ? '170px' : '156px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'basline' }}>
                                                    <div className="circlesIcon" style={{ backgroundColor: '#3dd856' }}><i class="fa fa-credit-card-alt" aria-hidden="true"></i></div>
                                                    <h5 className="bolder-font">{(0)?.toLocaleString("en-US")}</h5>
                                                </div>
                                                <h4>{'₹ ' + (Number(countData.total_penalty_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))}</h4>

                                                <h5>Penalty Amount</h5>
                                            </div>
                                        </div>

                                    </div>


                                </div>
                            </div>
                        </>

                        : ""}

                    {objectData && objectData.length > 0 ? (
                        <div className="phocket-table-new">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Details</th>
                                        <th className="text-center">Application Id</th>
                                        <th className="text-center">Due Date</th>
                                        <th className="text-center">Amount</th>
                                        <th className="text-center">Penalty</th>
                                        <th className="text-center">Principal</th>
                                        <th className="text-center">Interest</th>
                                        <th className="text-center">Bounce</th>
                                        <th className="text-center">Overdue Days</th>
                                        <th className="text-center">Processing Fee</th>
                                        <th className="text-center">Status</th>
                                        <th className="text-center">Expected Date</th>
                                        <th className="text-center">Payment Expectancy</th>
                                        <th className="text-center">Edit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((data, index) => (
                                        <tr key={index}>
                                            <td className="text-center">
                                                <i className="fa fa-info" style={{ cursor: 'pointer' }} onClick={() => userDetailHandler(data)}></i>
                                            </td>
                                            <td className="text-center">{data?.applicationId}</td>
                                            <td className="text-center">{moment(data?.emi_due_date).format('DD-MM-YYYY')}</td>
                                            <td className="text-center">{(data?.amount)?.toLocaleString("en-US")}</td>
                                            <td className="text-center">{(data?.penalty)?.toLocaleString("en-US")}</td>
                                            <td className="text-center">{(data?.principal)?.toLocaleString("en-US")}</td>
                                            <td className="text-center">{(data?.interest)?.toLocaleString("en-US")}</td>
                                            <td className="text-center">{data?.bounce}</td>
                                            <td className="text-center">{data?.overdue_days}</td>
                                            <td className="text-center">{(data?.processing_fee)?.toLocaleString("en-US")}</td>
                                            <td className="text-center">{data?.status ?? "-"}</td>
                                            <td className="text-center">{data?.expectedDate != null && data?.expectedDate !== undefined ? moment(data?.expectedDate).format('DD-MM-YYYY') : "-"}</td>
                                            <td className="text-center">{data?.paymentExpectancy ?? "-"}</td>
                                            <td className="text-center"><i class="fa fa-pencil-square-o" aria-hidden="true" style={{ cursor: 'pointer' }} onClick={(e) => EditData(e, data)}></i></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div style={{ float: 'right', marginTop: '20px' }}>
                                <Pagination
                                    count={Math.ceil(objectData.length / itemsPerPage)}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    color="primary"
                                />
                            </div>
                        </div>
                    ) : (
                        <p style={{ marginTop: '100px' }} className="text-center">
                            <img src={NodataImage} style={{ width: '30%' }} alt="No data available" />
                        </p>
                    )}
                </div>
                : ""}

            {popupdata.show ?
                <div className="background-blur">

                    <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', top: '20%' }}>
                        <i onClick={() => closePopup()} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>

                        <div className="row from-group">
                            <div className="col-xs-12" style={{marginBottom:'30px'}}>
                                <h4 className="text-center"><b>{popupdata?.data?.applicationId}</b></h4>
                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label htmlFor="">Status</label>
                                <input className='form-control' type="text" placeholder='Enter Status' value={editableFields.status} name="status" onChange={(e) => handleEditChange(e)} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label htmlFor="">Expected Date</label>
                                <input className='form-control' type="date" name="expectedDate" value={editableFields.expectedDate} onChange={(e) => handleEditChange(e)} />

                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <label htmlFor="">Payment Expectancy</label>
                                <input className='form-control' type="number" min={0} max={100} name="paymentExpectancy" value={editableFields.paymentExpectancy} onChange={(e) => handleEditChange(e)} />

                            </div>

                            <div className="col-xs-12">
                                <div className="text-center">
                                <button className="btn-primary" style={{margin:'30px 0 5px 0',padding:'8px',borderRadius:'6px'}} onClick={()=>updateDetails()}>Update</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                : ""}

        </>
    );
};

export default OverDueEmi;
